module.exports = __webpack_public_path__ + "img/theatres_5.e54603ea.png";